module.exports = __webpack_public_path__ + "static/img/zhao.b6d4eec1.png";